/**
 * JavaScript functions for retrieving and updating project completion percentage
 * Used to dynamically update the dashboard overlay without page refresh
 */

console.log('=== get-project-percentage.js loaded ===');

/**
 * Get current percent completed for a project via AJAX
 * @param {number} projectId - The WordPress post ID of the project
 * @param {function} successCallback - Callback function for successful response
 * @param {function} errorCallback - Callback function for error response
 */
window.getProjectPercentCompleted = function(projectId, successCallback, errorCallback) {
    console.log('getProjectPercentCompleted called with projectId:', projectId);
    var $ = jQuery;

    // Validate input
    if (!projectId || projectId <= 0) {
        console.error('Invalid project ID provided:', projectId);
        if (typeof errorCallback === 'function') {
            errorCallback('Invalid project ID');
        }
        return;
    }

    // Get the nonce
    var nonce = '';
    if (typeof projectDashboardNonce !== 'undefined' && projectDashboardNonce.nonce) {
        nonce = projectDashboardNonce.nonce;
        console.log('Nonce from projectDashboardNonce:', nonce);
    } else {
        nonce = $('input[name="project_dashboard_nonce"]').val() ||
                $('[data-nonce]').data('nonce') ||
                $('#project_dashboard_nonce').val();
        console.log('Nonce from DOM:', nonce);
    }

    if (!nonce) {
        console.error('Security nonce not found');
        if (typeof errorCallback === 'function') {
            errorCallback('Security token missing');
        }
        return;
    }

    console.log('Making AJAX request to:', ajax_object.ajax_url);

    // Make the AJAX request
    $.ajax({
        url: ajax_object.ajax_url,
        type: 'GET',
        data: {
            action: 'get_project_percent_completed',
            project_id: projectId,
            nonce: nonce
        },
        timeout: 10000,
        success: function(response) {
            console.log('AJAX success response:', response);
            if (response.success && response.data) {
                if (typeof successCallback === 'function') {
                    successCallback(response.data);
                }
            } else {
                var errorMessage = response.data && response.data.message ? response.data.message : 'Unknown error';
                console.error('AJAX response error:', errorMessage);
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMessage);
                }
            }
        },
        error: function(xhr, status, error) {
            console.error('AJAX error getting percent completed:', error);
            console.error('XHR status:', status);
            console.error('XHR response:', xhr.responseText);
            if (typeof errorCallback === 'function') {
                errorCallback('Network error occurred');
            }
        }
    });
};

console.log('window.getProjectPercentCompleted defined:', typeof window.getProjectPercentCompleted);

/**
 * Benchmark gauge overlay only — never home risk/asset chart empty-state overlays.
 */
function getHomeBenchmarkGaugeOverlay($) {
    var $overlay = $('.home-project-dashboard-widget .home-project-dashboard-gauge .incomplete-project-overlay');
    if ($overlay.length === 0) {
        $overlay = $('.home-project-dashboard-widget .gauge-content .incomplete-project-overlay');
    }
    return $overlay;
}

/**
 * Update the incomplete project overlay based on current percent completed
 * @param {number} projectId - The WordPress post ID of the project
 */
window.updateIncompleteProjectOverlay = function(projectId) {
    var $ = jQuery;

    window.getProjectPercentCompleted(projectId, function(data) {
        var $overlay = getHomeBenchmarkGaugeOverlay($);
        var $overlayContent = $overlay.find('.overlay-content');

        if ($overlay.length === 0) {
            return; // No overlay present (project might be completed)
        }

        // If project is now marked complete, hide the overlay
        if (data.project_completed) {
            $overlay.fadeOut();
            $('.gauge-content').removeClass('position-relative');
            return;
        }

        var percentCompleted = data.percent_completed;

        $overlay.show();

        if (percentCompleted >= 100) {
            // Show the "Finalize Data" button version
            $overlayContent.html(
                '<p class="overlay-message">This assessment data must be finalized in order to see benchmark data.</p>' +
                '<button type="button" class="btn btn-primary btn-mark-complete" id="markProjectCompleteBtn" data-project-id="' + projectId + '">' +
                    'Finalize Data' +
                '</button>'
            );
            // Carry the project's framework onto the button (js/home-dashboard.js stamps
            // these on the overlay); mark-complete-overlay.js reads them from the trigger.
            // Only when the overlay still belongs to this project (a newer selection may
            // have re-stamped it while this request was in flight).
            var $finalizeBtn = $overlayContent.find('#markProjectCompleteBtn');
            if (String($overlay.attr('data-project-id')) === String(projectId)) {
                ['data-project-slug', 'data-framework-slug', 'data-framework-id'].forEach(function(attr) {
                    var value = $overlay.attr(attr);
                    if (value) {
                        $finalizeBtn.attr(attr, value);
                    }
                });
            }
        } else {
            // Show the percentage message
            $overlayContent.html(
                '<p class="overlay-message">Answer all safeguards to finalize this project and view benchmark data.</p><p class="small text-muted">This assessment is currently ' + percentCompleted + '% complete.</p>'
            );
        }
    }, function(error) {
        console.error('Error updating overlay:', error);
    });
};

/**
 * Initialize overlay update when view-results modal is opened
 */
jQuery(document).ready(function($) {
    console.log('get-project-percentage.js document ready');

    // Update overlay when the viewResultsModal is shown; toggle body class so dashboard-options is only hidden when this modal is open
    var viewResultsModal = document.getElementById('viewResultsModal');
    if (viewResultsModal) {
        console.log('viewResultsModal found, attaching show.bs.modal listener');
        viewResultsModal.addEventListener('show.bs.modal', function() {
            document.body.classList.add('view-results-modal-open');
            viewResultsModal.classList.remove('view-results-content-loaded');
            console.log('viewResultsModal show.bs.modal event fired');
            startWatchingViewResultsLoader();

            // Small delay to ensure modal content is rendered
            setTimeout(function() {
                var $overlay = getHomeBenchmarkGaugeOverlay($);
                if ($overlay.length > 0) {
                    var projectId = $overlay.data('project-id');

                    // Fallback: try to get from button
                    if (!projectId) {
                        var $markCompleteBtn = $('#markProjectCompleteBtn');
                        projectId = $markCompleteBtn.data('project-id');
                    }

                    // Fallback: try to get from body class
                    if (!projectId) {
                        var bodyClasses = document.body.className;
                        var match = bodyClasses.match(/postid-(\d+)/);
                        if (match) {
                            projectId = parseInt(match[1], 10);
                        }
                    }

                    console.log('Updating overlay for project ID:', projectId);
                    if (projectId) {
                        window.updateIncompleteProjectOverlay(projectId);
                    }
                }
            }, 100);
        });
        viewResultsModal.addEventListener('hidden.bs.modal', function() {
            document.body.classList.remove('view-results-modal-open');
            viewResultsModal.classList.remove('view-results-content-loaded');
        });
    } else {
        console.log('viewResultsModal not found on page');
    }

    /**
     * When the View Results modal is open, watch the modal's loader (#view-results-modal-loader).
     * When it becomes hidden (chart code called .hide()), add view-results-content-loaded to the modal
     * so the dashboard-options dropdown inside the modal is shown.
     */
    function startWatchingViewResultsLoader() {
        var loaderEl = document.getElementById('view-results-modal-loader');
        if (!loaderEl || !viewResultsModal) return;
        var checkInterval = setInterval(function() {
            if (!document.body.classList.contains('view-results-modal-open')) {
                clearInterval(checkInterval);
                return;
            }
            var style = window.getComputedStyle(loaderEl);
            if (style.display === 'none' || style.visibility === 'hidden') {
                viewResultsModal.classList.add('view-results-content-loaded');
                clearInterval(checkInterval);
            }
        }, 100);
        // Stop polling after 30s in case loader never hides
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 30000);
    }

    // Also update when user returns to the tab (in case they filled out safeguards in another tab)
    $(document).on('visibilitychange', function() {
        if (!document.hidden) {
            var $overlay = getHomeBenchmarkGaugeOverlay($);
            if ($overlay.length > 0 && $overlay.is(':visible')) {
                var projectId = $overlay.data('project-id');
                if (projectId) {
                    console.log('Tab visible, updating overlay for project:', projectId);
                    window.updateIncompleteProjectOverlay(projectId);
                }
            }
        }
    });
});
